import type { DatatableColumnConfig } from '@/components/NewDesignSystem/NdsDatatable/NdsDatatable.interfaces'

import type { RunbookLabelRow, RunbookRow } from '@/contexts/recurring-tasks/Runbook.interfaces'

export enum RunbooksColumnId {
  NAME = 'name',
  RUNTASK_GROUPS = 'nb_runtask_groups',
  RUNTASKS = 'nb_runtasks',
  STATUS_365 = 'status_365',
  STATUS_PERIOD = 'status_p',
  ATTACHMENT = 'attachement',
  ACTIONS = 'actions',
}

export type RunbooksColumn = DatatableColumnConfig<RunbookRow> & { id: RunbooksColumnId }

export type RunbookLabelsColumn = DatatableColumnConfig<RunbookLabelRow> & { id: RunbooksColumnId }
